export const pains = [
  'Te preocupa la acidez y buscás alternativas naturales para tu mate.',
  'Te cuesta relajarte y buscás un ritual natural al terminar el día.',
  'Sentís que el estrés forma parte de tu rutina diaria.',
  'Te levantás sin energía y querés empezar el día de otra manera.',
  'Buscás bienestar natural, pero no sabés qué hierbas elegir.',
]

export const benefits = [
  'Aprenderás qué yuyos elegir para acompañar la digestión, el descanso y la energía.',
  'Descubrirás cómo preparar el mate ideal según cada momento del día.',
  'Sabrás combinar hierbas tradicionales sin dudas ni prueba y error.',
  'Podrás convertir cada mate en un ritual natural de bienestar.',
  'Disfrutarás un mate con más propósito, variedad y confianza.',
]

export type Bonus = {
  id: string
  emoji: string
  title: string
  description: string
  image: string
}

export const bonuses: Bonus[] = [
  {
    id: 'mockup-bono1',
    emoji: '📗',
    title: 'Bono 1 — El Detective de la Feria',
    description:
      'Una guía visual de reconocimiento. Fotos reales de las plantas secas y frescas, nombres científicos y la lista de qué preguntar para que el feriante sepa que sos un experto. Comprá con total seguridad y confianza.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/c7efd5c3-3a31-4924-9e25-6ae31a7f788b.jpg',
  },
  {
    id: 'mockup-bono2',
    emoji: '📘',
    title: 'Bono 2 — Alquimia Matera: 30 Blends para 30 Estados de Ánimo',
    description:
      'Un recetario dividido por momentos: Mate del Lunes de Enfoque, Mate Post-Asado del Domingo, Mate de Creatividad, Mate para la Alergia Primaveral. Variedad infinita para no aburrirte nunca.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/80e6df8d-2e47-45c0-afd7-aad2dfb08b2d.jpg',
  },
  {
    id: 'mockup-bono3',
    emoji: '📙',
    title: 'Bono 3 — Mate Social: Cómo Sobrevivir a la Ronda sin Taquicardia',
    description:
      'El protocolo para mate compartido. Qué hierbas aguantan más cebadas y cómo equilibrar el exceso de cafeína cuando la charla se alarga. Socializá sin sufrir los efectos secundarios.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/bb29e8b6-c7a7-4a53-8cb3-279e31f6e48f.jpg',
  },
  {
    id: 'mockup-bono4',
    emoji: '📕',
    title: 'Bono 4 — El Arte del Curado Profesional',
    description:
      'La guía definitiva para curar y mantener mates de calabaza, madera y hueso. Trucos para eliminar hongos y hacer que el poro de la calabaza absorba mejor los beneficios botánicos.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/f4c0d732-2a6b-421d-97e8-37c1f636442d.jpg',
  },
  {
    id: 'mockup-bono5',
    emoji: '📓',
    title: 'Bono 5 — Mate Biohacking: Neurociencia del Bienestar',
    description:
      'Por qué el Cedrón actúa sobre el nervio vago o cómo la Marcela bloquea receptores de acidez. Para el cliente escéptico que necesita entender el por qué antes de creer.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/b7fd9c85-092b-45a7-9a59-4166210aba75.jpg',
  },
]

export type Review = {
  name: string
  city: string
  text: string
  date: string
}

export const reviews: Review[] = [
  {
    name: 'María L.',
    city: 'Buenos Aires, Argentina 🇦🇷',
    text: 'Siempre tuve acidez con el mate y ya lo estaba abandonando. Con las combinaciones del libro empecé con Cedrón y Manzanilla y en una semana noté la diferencia. No puedo creer que sea tan simple. ¡Gracias!',
    date: '12 de julio',
  },
  {
    name: 'Carolina M.',
    city: 'Montevideo, Uruguay 🇺🇾',
    text: 'Me lo compré un domingo a la noche porque no podía dormir y buscaba algo natural. El capítulo del mate nocturno con Tilo y Valeriana cambió mi rutina completamente. Ahora duermo sin pastillas.',
    date: '9 de julio',
  },
  {
    name: 'Sebastián R.',
    city: 'Córdoba, Argentina 🇦🇷',
    text: 'Trabajo bajo muchísima presión y el estrés era constante. El Mate Anti-Estrés con Melisa que describe el libro se convirtió en mi ritual de las 18hs. Soy otra persona después de ese mate.',
    date: '5 de julio',
  },
  {
    name: 'Valentina G.',
    city: 'Salto, Uruguay 🇺🇾',
    text: 'Me levantaba sin energía todos los días y el café me ponía ansiosa. Probé el blend de mañana con Guaraná y Romero que propone el libro. Ahora arranco el día sin depender del café. Increíble.',
    date: '2 de julio',
  },
  {
    name: 'Lucas P.',
    city: 'Rosario, Argentina 🇦🇷',
    text: 'Fui a la feria botánica con el Bono Detective y fue otro nivel. El feriante me preguntó si era herborista. Gracias al libro sé exactamente qué pedir y por qué.',
    date: '28 de junio',
  },
  {
    name: 'Florencia T.',
    city: 'Maldonado, Uruguay 🇺🇾',
    text: 'Los 30 blends del bono son una locura. Tengo uno para cada día. El Mate Lunes de Enfoque con Ginkgo y Romero se convirtió en mi ritual antes de trabajar. Productividad al 100%.',
    date: '24 de junio',
  },
  {
    name: 'Martín H.',
    city: 'Mendoza, Argentina 🇦🇷',
    text: 'Era súper escéptico de esto, pero el Bono de Neurociencia me convenció. Cuando entendí por qué el Cedrón actúa sobre el nervio vago, dejé de dudar y empecé a experimentar. Los resultados hablan solos.',
    date: '20 de junio',
  },
  {
    name: 'Jimena V.',
    city: 'Paysandú, Uruguay 🇺🇾',
    text: 'Mi mate de calabaza tenía gusto horrible y lo iba a tirar. El Bono de Curado lo salvó. Ahora está perfecto y los yuyos saben diferente. No sé cómo no conocí esto antes.',
    date: '17 de junio',
  },
  {
    name: 'Agustín F.',
    city: 'La Plata, Argentina 🇦🇷',
    text: 'Las rondas de mate con amigos eran mi pesadilla, terminaba con taquicardia. Con el Bono Mate Social aprendí el protocolo y ahora disfruto sin sufrir. Esto debería enseñarse en todos lados.',
    date: '13 de junio',
  },
  {
    name: 'Natalia S.',
    city: 'Colonia, Uruguay 🇺🇾',
    text: 'Compré con miedo pero la garantía de 7 días me dio confianza. No la necesité porque el libro superó todas mis expectativas. Vale 10 veces más de lo que cuesta. Lo recomiendo sin dudarlo.',
    date: '10 de junio',
  },
]

export const faqs = [
  {
    question: '¿Este libro es un tratamiento médico?',
    answer:
      "No. 'El Secreto del Mate Perfecto' es un Ebook con fines exclusivamente educativos e informativos. Reúne conocimientos tradicionales sobre los yuyos y su uso en el mate, pero no reemplaza el diagnóstico, tratamiento o las recomendaciones de un profesional de la salud. Si tenés una condición médica, estás embarazada, en período de lactancia o tomás medicación, consultá con tu médico antes de incorporar nuevas hierbas a tu rutina.",
  },
  {
    question: '¿El libro es físico o digital?',
    answer:
      'Es un Ebook 100% digital en formato PDF. Podrás leerlo cómodamente desde tu celular, computadora o tablet, sin necesidad de esperar envíos físicos.',
  },
  {
    question: '¿Necesito conocimientos sobre yuyos para aprovechar el contenido?',
    answer:
      'No. El libro está pensado tanto para personas que recién comienzan como para quienes ya disfrutan del mate y quieren aprender a elegir, combinar y utilizar los yuyos con mayor confianza.',
  },
  {
    question: '¿Cuándo recibiré el libro?',
    answer:
      'El acceso es inmediato. Una vez confirmado tu pago, recibirás automáticamente el enlace para descargar el Ebook principal y los 5 bonos exclusivos incluidos en tu compra.',
  },
  {
    question: '¿Qué pasa si el libro no cumple mis expectativas?',
    answer:
      'Comprás con total tranquilidad gracias a nuestra Garantía de 7 Días. Explorá el contenido, descubrí el método y, si dentro de ese plazo sentís que el libro no era lo que esperabas, solo tenés que solicitar el reembolso y te devolveremos el 100% de tu dinero, sin complicaciones.',
  },
]

export const MAIN_MOCKUP =
  'https://cdn.magicpatterns.com/uploads/3FJcdV4ftNcJS5dbhPijza/ChatGPT_Image_3_sept_2026,_09_56_08_p.m..png'
